// extracted by mini-css-extract-plugin
export default {"box":"Box_box__44Im9","small":"Box_small__3OFoi Box_box__44Im9","count":"Box_count__o_DWT"};